import dynamic from 'next/dynamic';
import type { FC } from 'react';
import { Chip } from '@/DesignSystem/Component';
import { Comment } from '@/Module/Comment/Component';
import CommentListPagination from '@/Module/Comment/Component/CommentList/CommentListPagination';
import CommentInsert from '@/Module/Comment/Component/CommentRegister/CommentInsert';
import { useCommentList } from '@/Module/Comment/Hook';
import { IconComment } from '@/Module/Icon';
dynamic(() => import('./CommentListEmpty'));
const CommentListLoading = dynamic(() => import('./CommentListLoading'));
const CommentList: FC = () => {
  const {
    isLoading,
    commentIds
  } = useCommentList();
  const showSkeleton = isLoading && !commentIds.length;
  return <div className="group" data-sentry-component="CommentList" data-sentry-source-file="CommentList.tsx">
      <div className="mb-6 flex items-center">
        <Chip color="primaryMiddle" className="ml-2 !px-3" afterIcon={<IconComment size="small" />} title="" data-sentry-element="Chip" data-sentry-source-file="CommentList.tsx" />
        <span className="text-xl text-blueFour md:text-3xl">نظرات</span>
      </div>
      {showSkeleton && <CommentListLoading />}
      {!showSkeleton && <div className="flex flex-col border-b-4 border-l-8 border-r-4 border-t-8 border-blueFive bg-orangeThree p-4 sm:p-8">
          <CommentInsert />
          {commentIds.map(id => <Comment key={id} commentId={id} />)}
          <CommentListPagination />
        </div>}
    </div>;
};
export default CommentList;